export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7065c11aba6303585d42edc37b05b8f1ee577c3eaf&name=pushAdClickData!'